<style>
div {
    margin-top: 10px;
}

</style>

<script>
export let hideWidget
export let item

function shareOnFB(){
    var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent('https://plantogether.city/item/' + item.item_id)
    window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')
    hideWidget()
}

function shareOntwitter(){
    var url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent('https://plantogether.city/item/' + item.item_id) + '&via=plantogethermap&text=Plan Together - ' + item.item_title
    TwitterWindow = window.open(url, 'TwitterWindow','width=600,height=300')
    hideWidget()
}
</script>
<div>
    <button on:click={hideWidget}>Cancel</button>
    <button on:click={shareOnFB}>Facebook</button>
    <button on:click={shareOntwitter}>Twitter</button>
</div>